import { t } from "i18next";

import { PartTypeSchema, PartTypeType } from "shared";

export const getNestingLabel = (partType: PartTypeType | undefined | null) => {
  if (!partType) {
    return "";
  }

  let label = "";

  if (partType === PartTypeSchema.enum.SHEET) {
    label = t("part.nestingLabel.SHEET");
  }

  if (
    partType === PartTypeSchema.enum.ROUND_TUBE ||
    partType === PartTypeSchema.enum.SQUARE_TUBE ||
    partType === PartTypeSchema.enum.RECTANGULAR_TUBE
  ) {
    label = t("part.nestingLabel.TUBE");
  }

  if (partType === PartTypeSchema.enum.ROUND_BAR) {
    label = t("part.nestingLabel.ROUND_BAR");
  }

  if (partType === PartTypeSchema.enum.SQUARE_BAR) {
    label = t("part.nestingLabel.SQUARE_BAR");
  }

  if (partType === PartTypeSchema.enum.MACHINING) {
    label = t("part.nestingLabel.MACHINING");
  }

  return label.toLowerCase();
};
